<template>
  <hic-dialog append-to-body @open="loadData" :close-on-click-modal="false" :title="title" :visible="visible" width="44rem" top="10vh" @close="close">
    <el-skeleton :loading="loading" animated :rows="6"></el-skeleton>
    <el-scrollbar v-show="!loading" style="height: 40rem">
      <hic-print-simple :tmpl-code="tmplCode" :print-data="printData" ref="printer">
        <template #tools>
          <b class="sub-title">{{ hospitalization.patientName }} {{ hospitalization.bedNo }}床 {{ hospitalization.patientAge }}</b>
        </template>
      </hic-print-simple>
    </el-scrollbar>

    <div slot="footer">
      <el-button type="info" size="large" @click.native="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {},
    props: {
      visible: Boolean,
      hospitalization: Object,
      // term: String,
      type: String,
    },
    data() {
      return {
        loading: false,
        entities: {},
        condition: {
          states: ["启用", "待停止", "停止"],
          sort: "execTime",
          asc: true,
        },
        printData: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum", "user", "permission"]),
      tmplCode() {
        return this.type == "体征" ? "TiZhengJianCeDan" : "XueTangJianCeDan";
      },
      title() {
        return this.type == "体征" ? "生命体征监测单" : "血糖监测单";
      },
    },
    methods: {
      open() {
        this.loadData();
      },
      close() {
        this.$emit("update:visible", false);
      },
      loadData() {
        this.loading = true;
        let con = { ...this.condition, hospitalizationId: this.hospitalization.id };

        con.pageSize = 99999999;
        api.VitalSigns.query(con)
          .then((res) => {
            if (res.items.length) {
              this.printData = {
                Master: {
                  deptName: this.user.deptName,
                  ...this.hospitalization,
                },
                Detail: res.items
                  .filter((item) => (this.type == "血糖" && item.bloodGlucose) || (this.type == "体征" && (item.bloodPressure || item.pulse || item.temperature || item.respiration)))
                  .map((item) => ({
                    ...item,
                    execDt: this.$utils.Fmt.date(item.execTime),
                    execTm: this.$utils.Fmt.time(item.execTime),
                  })),
              };
              console.log(this.printData);
            } else {
              this.$message.warning("没有数据");
              this.printData = {
                Master: {
                  deptName: this.user.deptName,
                  ...this.hospitalization,
                },
                Detail: [],
              };
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      getFrequencyName(code) {
        let f = this.dict.DrugFrequency.find((item) => item.code == code);
        if (!f) {
          return code;
        }
        return f.shortCode;
      },
    },
  };
</script>
